import React from 'react';
import { WhatsAppOutlined, RightOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import './ContactSection.scss';


interface ContactSectionProps {
  onContactClick?: () => void;
}

const ContactSection: React.FC<ContactSectionProps> = ({ onContactClick }) => {
  const { t } = useTranslation('order_history');

  const handleContactClick = () => {
    if (onContactClick) {
      onContactClick();
    } else {
      window.open('https://bing/your-whatsapp-number', '_blank');
    }
  };

  return (
    <div className="contact-section-container">
      <div className="vls-section-title title-text">
        {t('contactVogueLaundry')}
      </div>

      <div onClick={handleContactClick} className="contact-button">
        <div className="whatsapp-icon">
          <WhatsAppOutlined />
        </div>
        <div className="contact-text">{t('chatWithVogueLaundry')}</div>
        <RightOutlined className="arrow-icon" />
      </div>
    </div>
  );
};

export default ContactSection;
